export default {
  processing: {
    en: 'Processing order',
  },
  onTheWay: {
    en: 'On the way',
  },
  arrivesIn: {
    en: 'Arrives in',
  },
  delivered: {
    en: 'Delivered',
  },
}
